import React, { useMemo } from 'react';
import { Flex } from '@chakra-ui/react';
import { CARTRIDGE_TYPE } from '../GamesList/cartridge';

export enum CartridgeSymbolVariant {
	MEDIUM,
	LARGE,
}

export const CartridgeSymbol = ({
	variant = CartridgeSymbolVariant.MEDIUM,
	symbol,
	type,
	color = 'white',
	customBackground,
}: {
	variant?: CartridgeSymbolVariant;
	symbol: string;
	type: string;
	color?: string;
	customBackground?: string;
}) => {
	const Body = ({ ...props }: any) => (
		<Flex
			// @ts-ignore
			background={customBackground || CARTRIDGE_TYPE[type]}
			padding="2px 4px"
			color={color}
			{...props}
		>
			{symbol.toUpperCase()}
		</Flex>
	);

	const typeOptions: any = {
		[CartridgeSymbolVariant.MEDIUM]: () => (
			<Body
				fontSize="6px"
				lineHeight="8px"
				borderRadius="3px"
				fontWeight="600"
			/>
		),
		[CartridgeSymbolVariant.LARGE]: () => (
			<Body
				fontSize="11px"
				lineHeight="13px"
				borderRadius="5px"
				fontWeight="400"
			/>
		),
	};

	const connectType = useMemo(() => {
		if (variant === CartridgeSymbolVariant.MEDIUM) {
			return CartridgeSymbolVariant.MEDIUM;
		}
		if (variant === CartridgeSymbolVariant.LARGE) {
			return CartridgeSymbolVariant.LARGE;
		}
		return CartridgeSymbolVariant.MEDIUM;
	}, [variant]);

	return typeOptions[connectType]();
};
